"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var React = require("react");
var stat_1 = require("~@/widget/stat/stat");
require("./nav.scss");
var Nav = (function (_super) {
    __extends(Nav, _super);
    function Nav(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hover: false
        };
        return _this;
    }
    Nav.prototype.render = function () {
        var catalogs = this.props.catalogs;
        var hover = this.state.hover;
        return (React.createElement("div", { className: "p-header__nav " + (hover ? 'p-header__nav--current' : '') + " " + (catalogs.length ? 'p-header__nav--with-drag' : ''), onMouseEnter: this.mouseEnter.bind(this), onMouseLeave: this.mouseLeave.bind(this) },
            React.createElement("a", { className: "p-header__nav__tl", href: "/catalog", target: "_blank", onClick: function () { return stat_1.stat(stat_1.EStatType.NAV_TITLE_CLICK); } },
                React.createElement("span", { className: "p-header__nav__tl__t" }, "\u5206\u7C7B"),
                React.createElement("i", { className: "p-header__nav__tl__icon" })),
            React.createElement("div", { className: "p-header__drag " + (hover ? 'p-header__drag--show' : '') },
                React.createElement("span", { className: "p-header__drag__enterstage" },
                    React.createElement("i", { className: "p-header__drag__enterstage__tri" }),
                    React.createElement("i", { className: "p-header__drag__enterstage__tri2" })),
                React.createElement("div", { className: "p-header__drag__main" },
                    React.createElement("div", { className: "p-header__nav__main" }, catalogs.map(function (catalog, i) {
                        return (React.createElement("div", { className: "p-header__nav__main__section", key: i },
                            React.createElement("h3", { className: "p-header__nav__main__section__tl" }, catalog.title),
                            React.createElement("ul", { className: "p-header__nav__main__section__cnt" },
                                catalog.navs.map(function (nav, index) {
                                    if (index <= 6) {
                                        return (React.createElement("li", { className: "p-header__nav__main__section__cnt__item", key: index },
                                            React.createElement("a", { className: "p-header__nav__main__section__cnt__item__link", href: nav.url, onClick: function () { return stat_1.stat(stat_1.EStatType.NAV_ITEM_CLICK, [catalog.title]); } },
                                                React.createElement("span", { className: "p-header__nav__main__section__cnt__item__link__t" }, nav.title))));
                                    }
                                    else {
                                        return '';
                                    }
                                }),
                                React.createElement("li", { className: "p-header__nav__main__section__cnt__item" },
                                    React.createElement("a", { className: "p-header__nav__main__section__cnt__item__link", href: catalog.url },
                                        React.createElement("span", { className: "p-header__nav__main__section__cnt__item__link__t" }, "\u5168\u90E8"))))));
                    }))))));
    };
    Nav.prototype.mouseEnter = function () {
        var catalogs = this.props.catalogs;
        if (catalogs.length) {
            this.setState({
                hover: true
            });
        }
    };
    Nav.prototype.mouseLeave = function () {
        this.setState({
            hover: false
        });
    };
    return Nav;
}(React.Component));
exports.Nav = Nav;
